import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import RenamePopup from '../../category/view/popup/renameCategory';
import { useDispatch, useSelector } from 'react-redux';
import { CardsCategoryAction } from '../model/cardActions';
import NoContentFound from '../../default/not-found/notFound';
import { ShimmerPostList } from 'react-shimmer-effects';
import SearchForm from '../../default/search/searchForm';
import { handleAddItem, handleAddToCategory, handleCategoryDelete, renameCategoryAction } from '../../../store/actions/new/categoryActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import AddNewCategoryPopup from '../../category/view/popup/addNewCategory';
import ItemsSelectorPopup from '../../default/popup/itemsSelectorPopup';
import { CARD_CATEGORY_DELETE, CARD_CATEGORY_UPDATE } from '../../../store/actions/types';
import ShimmerImage from '../../default/popup/shimmerImage/shimmerImage';
import { InitialAvatar } from '../../default/utils/defaultAvatar';
import DataModelPopup from '../../default/popup/dataModel/contentModelPopup';
import SingleCardCategoryList from './single/singleCategoryData';
import { handleCtrlLink } from '../../default/utils/ctrlLink';


const CardCategoryList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };


    //Modal
    const [openModal, setOpen] = useState(false);
    const [catTitle, setCatTitle] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [openDataPopup, setDataPopup] = useState(false);
    const [openCategoryItemModal, categoryItemModalSet] = useState(false);
    const [openRenameModal, renameSet] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [catItem, setCatItem] = useState('');
    const prevSearchTermRef = useRef();
    //add category modal
    const handleAddNewModal = () => {
        setOpen(true);
    };
    const handleCloseModal = () => {
        setDataPopup(false);
    };

    const handleAddCategoryRes = (response) => {
        if (response.status >= 200 ){
            let postData = {
                page   : 1,
                keyword: ''
            }
            dispatch(CardsCategoryAction(postData));
        }
    }
    //add item into category modal
    const handleAddItemModal = (id, title) => {
        setCategoryId(id)
        setCatTitle(title)
        categoryItemModalSet(true);
    };
    const handleItemSelect = async (item) => {
        console.log(item);
        setCatItem(item);
        categoryItemModalSet(false);
       let response = await dispatch(handleAddItem(categoryId, item, catTitle));

        if(response){
            dispatch(handleAddToCategory(categoryId, item, catTitle));
        }
    };
    // Rename category modal
    const handleRenameModal = (id, title) => {
        setCategoryId(id)
        setCatTitle(title)
        renameSet(true);
    };
    // Rename category
    const handleUpdateCategory = async (newCategoryName) => {
        setCatTitle(newCategoryName);
        
        try {
            const response = await dispatch(renameCategoryAction(categoryId, newCategoryName)); 
            if (response.status >= 200) {
                dispatch({
                    type: CARD_CATEGORY_UPDATE,
                    payload: {
                        catId: categoryId,
                        title: newCategoryName, 
                        data: response.data
                    }
                });
                return true;
            }
        } catch (error) {
            console.error('Failed to update category:', error);
        }
    }
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (event.target.closest('.list-edit-dropdown') === null && !openCategoryItemModal && !openRenameModal) {
            setOpenDropdown(null);
        }
    };
    //remove category
    const MySwal = withReactContent(Swal)
    const handleDeleteCategory = (catId, type) => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden"; 
              },
              willClose: () => {
                document.body.style.overflow = ""; 
              }
        }).then(async (result) => {
            if (result.isConfirmed) {
              let response = await dispatch(handleCategoryDelete(catId, type));
              if(response.status >= 200){
                dispatch({
                    type: CARD_CATEGORY_DELETE,
                    payload: {
                        catId: catId
                    }
                })
              }
            }
        });

    }
    // Store data
    const allData = useSelector((state) => state.cardData);
    const { category, error, isLoading } = allData;
    const { data, pagination } = category;
    const dispatch = useDispatch();
    // Search category action
    const searchCategory = async () => {
        if (!hasLoaded) return;
        setLoading(true);
        let postData = {
            page: 1,
            keyword: searchTerm
        }
        await dispatch(CardsCategoryAction(postData));
        setLoading(false);
    }
    // Load more action
    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page: nextPage,
                keyword: searchTerm
            }
            dispatch(CardsCategoryAction(postData));
        }
    };
    // data model popup
    const handleDataPopup = (event, dataId) => {
        event.preventDefault();
        setDataPopup(false);
        setCategoryId(null);
        setTimeout(() => {
            setCategoryId(dataId);
            setDataPopup(true);
        }, 100);
    }

    React.useEffect(() => {
        if (!hasLoaded) {
            // Check if store already has data
            if (!category || !category.data || category.data.length === 0) {
                let postData = {
                    page: 1,
                    keyword: ''
                }
                dispatch(CardsCategoryAction(postData));
            }
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchCategory();
        }
        prevSearchTermRef.current = searchTerm;

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [openCategoryItemModal, openRenameModal, searchTerm]);
    return (
        <div className="card-container card-list-area">
            <div className="connection-header">
                <h3>Card category</h3>
                <div className="filter-wrapper">
                    <SearchForm
                        placeholder='Search Category...'
                        loading={loading}
                        onChange={async (val) => {
                            setSearchTerm(val);
                        }}

                    />
                    <div className="list-filter">
                        <i className="ri-equalizer-line"></i>
                        <span>Filter</span>
                    </div>
                    <div className="list-filter add-new-btn" onClick={handleAddNewModal}>
                        <i className="ri-add-line"></i>
                        <span>Add New</span>
                    </div>
                </div>
            </div>
            {Array.isArray(data) && data.length > 0 && (
                <div className="connection-cat-list">
                    {data && data.map((item, index) => (
                        <div className="single-category-card" key={index} onClick={(e) => {handleDataPopup(e, item.id)}}>
                            <div className="cat-info">
                                <h3>
                                    <Link onClick={(e) => handleCtrlLink(e, `/card/category/${item.id}`)}  to={`/card/category/${item.id}`}>{item.title}</Link>
                                </h3>
                                <div className="list-edit-dropdown cat-dropdown" onClick={(e) => {e.stopPropagation()}}>
                                    <i
                                        className="ri-more-2-fill"
                                        onClick={(e) => toggleDropdown(index)}
                                    ></i>
                                    {openDropdown === index && (
                                        <ul>
                                            <li>
                                                <Link 
                                                    to={`/card/category/${item.id}`} 
                                                    onClick={() => setOpenDropdown(null)} 
                                                >
                                                    View Category
                                                </Link>
                                            </li>
                                            <li>
                                                <Link 
                                                    onClick={() => {
                                                        handleAddItemModal(item.id, item.type);
                                                        setOpenDropdown(null); 
                                                    }}
                                                >
                                                    Add Card
                                                </Link>
                                            </li>
                                            <li>
                                                <Link 
                                                    onClick={() => {
                                                        handleRenameModal(item.id, item.title);
                                                        setOpenDropdown(null); 
                                                    }}
                                                >
                                                    Rename 
                                                </Link>
                                            </li>
                                            <li>
                                                <Link 
                                                    onClick={() => {
                                                        handleDeleteCategory(item.id, item.type);
                                                        setOpenDropdown(null); 
                                                    }}
                                                >
                                                    Delete
                                                </Link>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                            {item.itemCount > 0 && (
                                <Link onClick={(e) => handleCtrlLink(e, `/card/category/${item.id}`)} to={`/card/category/${item.id}`} className="category-user-list">
                                    <ul>
                                        {item.items.slice(0, 5).map((catItem, catIndex) => (
                                            <li key={catIndex}>
                                                {catItem.photo ? (
                                                    <ShimmerImage
                                                        src={catItem.photo}
                                                        alt={catItem.title}
                                                        width={80}
                                                    />
                                                ) : (
                                                    <InitialAvatar
                                                        title={`${catItem.title}`}
                                                        borderWidth={2}
                                                        size={80}
                                                    />
                                                )}
                                            </li>
                                        ))}
                                        {item.itemCount > 5 && (
                                            <li className="more-items">
                                                +{item.itemCount - 5} more
                                            </li>
                                        )}
                                    </ul>
                                </Link>
                            )}
                            {!isLoading && item.itemCount === 0 && (
                                <div className="no-content-wrapper" onClick={(e) => e.stopPropagation()}>
                                    <NoContentFound title="No item found!" />
                                    <Link onClick={() => handleAddItemModal(item.id, item.type)}>Add item</Link>
                                </div>
                                )
                            }
                        </div>
                    ))}
                </div>
            )}

            {!isLoading && Array.isArray(data) && data.length === 0 &&
                <NoContentFound title="No category found!" />
            }
            {isLoading &&
                <>
                    <ShimmerPostList title cta row={2} col={3} />
                </>
            }
            {!isLoading && data && pagination.page_last > pagination.page && (
                <div className="load-more-container">
                    <button
                        className="load-more-btn"
                        onClick={loadMore}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}

            <ItemsSelectorPopup openModal={openCategoryItemModal} setOpen={categoryItemModalSet} onItemSelect={handleItemSelect} type="cards" title="Add category item" />
            <RenamePopup openModal={openRenameModal} setOpen={renameSet} title={catTitle} onCategoryUpdate={handleUpdateCategory}/>
            <AddNewCategoryPopup openModal={openModal} setOpen={setOpen} type="cards" onSubmitResponse={handleAddCategoryRes} />
            <DataModelPopup openModal={openDataPopup} setOpen={setDataPopup} bodyData={<SingleCardCategoryList popupItemId={categoryId} onClose={handleCloseModal} />} />
        </div>
    );
}

export default CardCategoryList;
